import { getCloudPACSToken } from "@custom/Utils/authUtils";
import { _machineUrls } from "@custom/Utils/constants/apiUrls";
import { ApiResponse, MachineProps } from "@custom/Utils/constants/interfaces";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getDeviceName = {
    getDeviceNameSlice: createAsyncThunk(
        "machine/get",
        async (props: MachineProps, { rejectWithValue }) => {
            const pacs_token = getCloudPACSToken();
            try {
                const response = await fetch(
                    _machineUrls.getDevice(props.deviceName),
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${pacs_token}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error('Failed to fetch device name');
                }

                const data: ApiResponse<any> = await response.json();
                return Array.isArray(data) ? data : [data]; // Ensures returned data is an array
            } catch (error) {
                return rejectWithValue(error.message || 'Unknown error occurred');
            }
        }
    ),
};
